import { Icon, iconSizes } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import { ICategory } from "shared/hubrise/models"
import { isFakeDealCategory } from "shared/hubrise/utils/Deal"

import { Description, EditButton, Name, Title, StyledCategory, EditIcon } from "./Styles"

interface CategoryProps {
  category: ICategory
  isEmpty: boolean
  className?: string
}

const Category = ({ category, isEmpty, className }: CategoryProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { catalogNavigation } = useCatalogNavigation()

  const editPath = catalogNavigation.editPath("category", category.id)
  const handleEdit = (event: React.MouseEvent) => {
    event.stopPropagation()
    navigate(editPath)
  }

  const specialDescription = isFakeDealCategory(category)
    ? t("preview.deal_category_description")
    : isEmpty
      ? t("preview.empty_category_description")
      : null

  return (
    <StyledCategory className={className} data-item-id={category.id}>
      <Title>
        <Name onClick={() => navigate(catalogNavigation.previewPath("category", category.id))}>{category.name}</Name>

        <EditButton onClick={handleEdit}>
          <EditIcon />
        </EditButton>
      </Title>

      {category.description ? (
        <Description dangerouslySetInnerHTML={{ __html: category.description }} />
      ) : (
        specialDescription !== null && (
          <Description>
            <Icon code="info" size={iconSizes._20} />
            {specialDescription}
          </Description>
        )
      )}
    </StyledCategory>
  )
}

export default Category
